import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['dropdown', 'current'];
  static values = {
    projectId: String,
    fromColumnName: String,
  };

  projectColumns = {};

  connect() {
    document.addEventListener('click', (event) => {
      if (!this.element.contains(event.target) && !this.dropdownTarget.classList.contains('hide')) {
        this.dropdownTarget.classList.add('hide');
      }
    });

    const projectId = this.projectIdValue;
    if (this.hasFromColumnNameValue) {
      this.projectColumns[projectId] = this.fromColumnNameValue;
    }

    this.hideCurrentColumnFromDropdown();
  }

  toggleDropdown(event) {
    event.preventDefault();
    this.dropdownTarget.classList.toggle('hide');
  }

  hideCurrentColumnFromDropdown() {
    const projectId = this.projectIdValue;
    const currentColumn = this.projectColumns[projectId] || this.fromColumnNameValue;
    const dropdownOptions = this.dropdownTarget.querySelectorAll('[data-raw_column_name]');
    const currentOption = this.dropdownTarget.querySelector(
      `[data-raw_column_name="${currentColumn}"]`
    );

    dropdownOptions.forEach((option) => {
      option.style.display = '';
    });

    if (currentOption) {
      currentOption.style.display = 'none';
    }
  }

  async selectStatus(event) {
    event.preventDefault();

    const projectId = this.projectIdValue;
    const fromColumn = this.projectColumns[projectId] || this.fromColumnNameValue;
    const toKanbanColumn = event.currentTarget.dataset.raw_column_name;
    const toKanbanColumnParsed = event.currentTarget.dataset.column_name.replace(/-/g, ' ');

    if (fromColumn === toKanbanColumn) {
      this.dropdownTarget.classList.add('hide');
      return;
    }

    const response = await fetch(`/kanban/project/${projectId}/xhr_update_kanban_column`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
      },
      body: new URLSearchParams({
        from_kanban_column: fromColumn,
        to_kanban_column: toKanbanColumn,
      }),
    });

    if (!response.ok) {
      console.error('❌ Failed to update kanban column');
      return;
    }

    this.projectColumns[projectId] = toKanbanColumn;
    this.currentTarget.querySelector('.status-badge').textContent = toKanbanColumnParsed;
    this.dropdownTarget.classList.add('hide');
    this.hideCurrentColumnFromDropdown();
  }
}
